module.exports = __webpack_public_path__ + "assets/img/avatar_cleo.e30139d6.png";